module.exports = __webpack_public_path__ + "static/media/Track.7df17027.gif";